import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {DataLoadingBaseUploadResult} from 'components/data-loading-base/Types';
import ApiService from 'redux/services/api-service';

export type UploadResult = DataLoadingBaseUploadResult & {
  retailers_set_to_not_confirmed: string[];
  tdlinx_retailers_set_to_not_confirmed: string[];
  tdlinx_set_to_not_confirmed: string[];
  require_admin_reasons: string[];
};

export interface IState {}

export const storeDataLoadingEndpoints = {
  getAdapters: createAsyncThunk('storeDataLoading/getAdapters', async (params: any) => {
    const response = await ApiService.get(`/store_data_loading/adapters/?${new URLSearchParams(params).toString()}`);
    return response.data;
  }),
  getRetailers: createAsyncThunk('storeDataLoading/getRetailers', async (params: any) => {
    const response = await ApiService.get(`/store_data_loading/retailers/?${new URLSearchParams(params).toString()}`);
    return response.data;
  }),
  uploadStoreList: createAsyncThunk('storeDataLoading/uploadStoreList', async (payload: any) => {
    const response = await ApiService.put(`/store_data_loading/upload/`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }),
};
export const storeDataLoadingSlice = createSlice({
  name: 'storeDataLoading',
  initialState: {} as IState,
  reducers: {},
});

export const storeDataLoadingActions = storeDataLoadingSlice.actions;

export type StoreDataLoadingSlice = {
  [storeDataLoadingSlice.name]: ReturnType<(typeof storeDataLoadingSlice)['reducer']>;
};
